<!-- AssetServiceRightSidebar -->
<template>
  <Sidebar
    v-model:visible="trigger"
    :style="{ width: sidebarwidth }"
    position="right"
  >
    <template #header>
      <div class="d-flex align-items-center w-100">
        <h6 class="w-100 mb-0">
          {{ t("assetManagement.service.service") }}
        </h6>
        <div>
          <i class="pi pi-times" @click="closedetailsrightsidebar()"></i>
        </div>
      </div>
    </template>
    <div class="sidebar-container">
      <!-- Main sidebar content -->
      <div
        class="sidebar-content main-content"
        :class="{ extended: isExtended }"
      >
        <b-container>
          <b-form @submit.prevent="saveMaintenanceSchedule">
            <b-row>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <TextField
                    v-model="serviceForm.Code"
                    placeholder=" "
                    :requiredIcon="true"
                    clearable
                    name="code"
                    id="code"
                    :label="$t('assetManagement.service.code')"
                    :rules="{ required: true }"
                    disabled
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <label>{{ t("assetManagement.service.asset") }}</label>
                  <AutoCompleteCustom
                    :rules="{ required: true }"
                    :required-icon="true"
                    placeholder="Type atleast 3 letters"
                    :id="t('assetManagement.service.asset')"
                    v-model="serviceForm.AssetName"
                    :items="assetList"
                    @input="LoadAsset(serviceForm.AssetName)"
                    @item-select="assetSelect"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <CustomDropDown
                    v-model="serviceForm.Reason"
                    :items="reasonList"
                    :label="t('assetManagement.service.reason')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="reason"
                    name="reason"
                    @change="reasonChange(serviceForm.Reason)"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12" v-if="serviceForm.Reason">
                <div class="field">
                  <TextField
                    v-model="serviceForm.Issue"
                    placeholder=" "
                    clearable
                    name="issue"
                    id="issue"
                    :label="$t('assetManagement.service.issue')"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <CustomDropDown
                    v-model="serviceForm.SupplierId"
                    :items="supplierList"
                    :label="t('assetManagement.service.supplier')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="supplier"
                    name="supplier"
                    :disabled="false"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <CustomDatepicker
                    v-model="serviceForm.ExpectedReturnDate"
                    :label="t('assetManagement.service.expectedreturndate')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="expectedreturndate"
                    name="expectedreturndate"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12" v-if="tableId !== 0">
                <div class="field">
                  <CustomDatepicker
                    v-model="serviceForm.ActualReturnDate"
                    :label="t('assetManagement.service.actualreturndate')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="actualreturndate"
                    name="actualreturndate"
                  />
                </div>
              </b-col>

              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <CustomDropDown
                    v-model="serviceForm.MaintenanceId"
                    :items="maintenanceTypeList"
                    :label="t('assetManagement.service.maintenancetype')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="MaintenanceType"
                    name="MaintenanceType"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <CustomDropDown
                    v-model="serviceForm.AssignTo"
                    :items="technicianList"
                    :label="t('assetManagement.service.technician')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="technician"
                    name="technician"
                  />
                </div>
              </b-col>

              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <CustomDropDown
                    v-model="serviceForm.Priority"
                    :items="priorityList"
                    :label="t('assetManagement.service.priority')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="priority"
                    name="priority"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <CustomDropDown
                    v-model="serviceForm.Status"
                    :items="statusList"
                    :label="t('assetManagement.service.status')"
                    :rules="{ required: true }"
                    :required-icon="true"
                    id="status"
                    name="status"
                  />
                </div>
              </b-col>

              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <TextField
                    v-model="serviceForm.CostEstimate"
                    type="number"
                    :label="t('assetManagement.service.costestimate')"
                    id="costestimate"
                    name="costestimate"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12" v-if="tableId !== 0">
                <div class="field">
                  <TextField
                    v-model="serviceForm.ActualCost"
                    type="number"
                    :label="t('assetManagement.service.actualcost')"
                    id="actualcost"
                    name="actualcost"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="5" sm="6" cols="12">
                <div class="field">
                  <Textarea
                    v-model="serviceForm.ResolutionRemarks"
                    :label="t('assetManagement.service.resolutionremarks')"
                    id="resolutionremarks"
                    name="resolutionremarks"
                    :rows="3"
                  />
                </div>
              </b-col>

              <div class="d-flex flex-row-reverse mt-4">
                <Footer
                  @cancel="closedetailsrightsidebar"
                  :label="btnLabel"
                  :cancelhide="false"
                  :loading="scheduleLoading"
                />
              </div>
            </b-row>
          </b-form>
        </b-container>
      </div>
    </div>
  </Sidebar>
  <CreateSuccessully :visible="createpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  watchEffect,
} from "vue";
import { useI18n } from "vue-i18n";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatepicker from "../../../../../../../components/FormComponents/DatePicker.vue";
import NormalTableview from "../../../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import Textarea from "../../../../../../../components/FormComponents/TextArea.vue";
import { useRoute } from "vue-router";
import { useForm } from "vee-validate";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { useToast } from "primevue/usetoast";
import StoreService from "../../../../../Service/StoreService";
import MaintenanceScheduleMasterServices from "../../../../../Service/AssetManagement/MaintenanceScheduleMasterService";
import AutoCompleteCustom from "../../../../../../../components/FormComponents/AutoComplete.vue";
import AssetMasterService from "../../../../../Service/AssetManagement/AssetMasterService";
import AssetMaintenanceService from "../../../../../Service/AssetManagement/AssetMaintenanceService";
import CheckListMasterService from "../../../../../Service/AssetManagement/CheckListMasterService";
import Sidebar from "primevue/sidebar";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
// import Checkbox from 'primevue/checkbox';
// import Toast from 'primevue/toast';
import moment from "moment";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import { log } from "console";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import stockReasonService from "../../../../../Service/StockReasonService";
import EscalationService from "../../../../../Service/AssetManagement/EscalationService";
import Itemservice from "../../../../../Service/ItemMasService";
import common from "../../../../../Service/CommonService";
import supplierService from "../../../../../Service/SupplierMaster";
import AssetService from "../../../../../Service/AssetManagement/AssetServiceManagementService";
export default defineComponent({
  props: {
    trigger: {
      type: Boolean,
      default: true,
    },
    tableId: {
      type: String,
      default: "",
    },
  },
  components: {
    Textarea,
    Footer,
    TextField,
    CustomDropDown,
    CustomDatepicker,
    NormalTableview,
    SkeletonTableLoader,
    AutoCompleteCustom,
    Sidebar,
    Tableview,
    UpdatedSuccessfully,
    CreateSuccessully,
    AlreadyExist,
  },
  setup(props, { emit }) {
    const showdetailrightsidebar = ref(false);
    const toast = useToast();
    const confirmationmodel = ref(false);
    const route = useRoute();
    const alreadyexistpop = ref(false);
    const updatepop = ref(false);
    const createpop = ref(false);
    const scheduleLoading = ref(false);
    const maintenanceTypeList = ref([]);
    const technicianList = ref([]);
    const reasonList = ref([]);
    const supplierList = ref([]);
    const show = ref();
    const tableId = ref(props.tableId);
    const { t } = useI18n();
    const { handleSubmit, resetForm, validate } = useForm();
    const checklistArray = ref([]);
    const assetList = ref([]);
    const sidebarwidth = ref("55rem");
    const btnLabel = ref(t("btn.save"));
    const isExtended = ref(false);
    const skeletonloading = ref(false);
    const escalationTableList = ref([]);
    let SessionUserData = localStorage.getItem("UsersData");
    let SessionEntitydata = localStorage.getItem("EntityData");
    let SessionRolesData = localStorage.getItem("RolesData");

    let Entitydata;
    if (SessionEntitydata !== null) {
      Entitydata = JSON.parse(SessionEntitydata);
    }

    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let roleData;
    if (SessionRolesData !== null) {
      roleData = JSON.parse(SessionRolesData);
    }
    const ParamValues = ref({
      StoreId: Number(route.query.Id ?? 0),
      BranchId: Number(route.query.BranchId ?? 0),
    });
    const closedetailsrightsidebar = () => {
      emit("closedetailsrightsidebar");
      Object.assign(serviceForm.value, copyserviceForm);
    };

    // Dropdown options
    const priorityList = ref([
      { name: "Low", value: 1 },
      { name: "Medium", value: 2 },
      { name: "High", value: 3 },
    ]);
    const statusList = ref([
      { name: "Open", value: 1 },
      { name: "In Progress", value: 2 },
      { name: "In Hold", value: 3 },
      { name: "Cancelled", value: 4 },
      { name: "Closed", value: 5 },
    ]);

    const serviceForm = ref({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2025-09-23T14:13:05.765Z",
      ModifiedAt: "2025-09-23T14:13:05.765Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ModifiedByName: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsEntitySMS: 0,
      OrganizationName: "",
      OrganizationId: 0,
      BranchName: "",
      FromStoreBranchName: "",
      ToStoreBranchName: "",
      StoreName: "",
      FromStoreName: "",
      ToStoreName: "",
      SupplierName: "",
      RowNumber: 0,
      TaskStatus: 0,
      TaskExpiryDate: "2025-09-23T14:13:05.765Z",
      TaskName: "",
      TaskPriority: 0,
      IsApprovalRequired: true,
      LevelsOfApproval: 0,
      Id: 0,
      Code: "",
      AssetId: 0,
      AssetName: "",
      MaintenanceId: 0,
      Issue: "",
      SupplierId: 0,
      FromStoreId: 0,
      ExpectedReturnDate: "",
      ActualReturnDate: "",
      AssignTo: 0,
      Priority: 0,
      Status: 0,
      ResolutionRemarks: "",
      CostEstimate: 0,
      ActualCost: 0,
      UpdatedBy: 0,
      UpdatedAt: "2025-09-23T14:13:05.765Z",
      ClosedBy: 0,
      ClosedAt: "2025-09-23T14:13:05.765Z",
      StoreId: 0,
      Reason: 0,
    });
    const copyserviceForm = JSON.parse(JSON.stringify(serviceForm.value));

    watch(
      () => props.trigger,
      async (newval) => {
        if (newval) {
          tableId.value = props.tableId;
          if (tableId.value == 0) {
            GetCode();
          } else {
            IsEdit();
          }
          LoadreasonList();
          LoadSupplierList();
          LoadIMaintenanceScheduleMaster();
          LoadUser();
        }
      }
    );

    async function IsEdit() {
      try {
        btnLabel.value = t("btn.update");
        const result = await AssetService.getfindonedata(tableId.value);
        let resfields = result["result"];

        Object.keys(serviceForm.value).forEach((key) => {
          if (resfields[key]) serviceForm.value[key] = resfields[key];
        });
        // serviceForm.value.Code = "ASS00004"
      } catch (error) {
        console.error("Error in IsEdit function:", error);
      }
    }
    //Load Item Autocomplete
    async function LoadAsset(assetName) {
      try {
        if (assetName.length >= 3) {
          const data_response: any =
            await AssetMasterService.getAssetIdbyAutoComplete(
              assetName,
              usersData.HospitalId,
              usersData.BranchId,
              ParamValues.value.StoreId
            );
          console.log(data_response);
          // Check if result exists and is an array
          if (
            data_response &&
            data_response.result &&
            Array.isArray(data_response.result)
          ) {
            assetList.value = data_response.result
              // .filter((item) => item.StatusID == 1)
              .map((item) => {
                return {
                  label:
                    item.AssetName +
                    " | " +
                    item.AssetDisplayId +
                    " | " +
                    item.BarCode,
                  value: item.AssetId,
                  barcodeNo: item.BarCodeNo,
                  barCode: item.BarCode,
                  supplierId: item.SupplierName,
                };
              });
          }
        }
      } catch (error) {
        console.log(error);
        assetList.value = [];
      }
    }
    function assetSelect(data) {
      serviceForm.value.AssetId = data.value.value;
      serviceForm.value.SupplierId = data.value.supplierId;
    }
    function reasonChange(data) {
      let issue = reasonList.value.find((item) => item.value === data);
      if (issue) {
        serviceForm.value.Issue = issue.name;
      } else {
        serviceForm.value.Issue = "";
      }
    }
    async function LoadUser() {
      try {
        const data_response = await StoreService.ListUserByStoreId(
          ParamValues.value.StoreId,
          usersData.HospitalId
        );
        console.log(data_response);

        // Check if result exists and is an array
        if (
          data_response &&
          data_response.result &&
          Array.isArray(data_response.result)
        ) {
          technicianList.value = data_response.result.map((item) => {
            return {
              name: item.UserName,
              value: item.ID,
            };
          });
        } else {
          console.warn(
            "LoadUser: Invalid response or result is not an array",
            data_response
          );
          technicianList.value = [];
        }
      } catch (error) {
        console.log(error);
        technicianList.value = [];
      }
    }
    async function LoadIMaintenanceScheduleMaster() {
      try {
        const response = await MaintenanceScheduleMasterServices.getdata();

        // Check if result exists and is an array
        if (response && response.result && Array.isArray(response.result)) {
          maintenanceTypeList.value = response.result.map((item) => {
            return {
              name: item.MaintenanceType,
              value: item.Id,
            };
          });
        } else {
          maintenanceTypeList.value = [];
        }
      } catch (error) {
        console.log(error);
        maintenanceTypeList.value = [];
      }
    }
    async function LoadreasonList() {
      try {
        const response = await stockReasonService.getlistdata();

        if (response && response.result) {
          reasonList.value = response.result.map((item) => {
            return {
              name: item.ReasonName,
              value: item.Id,
            };
          });
        } else {
          reasonList.value = [];
        }
      } catch (error) {
        console.log(error);
        reasonList.value = [];
      }
    }

    async function LoadSupplierList() {
      try {
        const response = await supplierService.GetSuppliersByStoreId(
          ParamValues.value.StoreId,
          ParamValues.value.BranchId
        );
        if (response && response.result) {
          supplierList.value = response["result"]
            .filter((i1) => i1.IsActive == true)
            .map((item: any) => {
              return {
                name: item.Name,
                value: item.Id,
              };
            });
        } else {
          supplierList.value = [];
        }
      } catch (error) {
        console.log(error);
        supplierList.value = [];
      }
    }

    //AutoGenerate Code Template
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 9,
        EntityId: Entitydata.EntityId,
        HospitalId: usersData.HospitalId,
        BranchId: usersData.BranchId,
        StoreId: ParamValues.value.StoreId,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      serviceForm.value.Code = result;
    }

    const saveMaintenanceSchedule = async () => {
      // Run validation on all fields
      const results = await validate();
      if (results.valid) {
        try {
          scheduleLoading.value = true;
          let response: any;
          let message = "";

          serviceForm.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          serviceForm.value.ModifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          serviceForm.value.UpdatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          serviceForm.value.ClosedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          serviceForm.value.BranchId = Number(usersData.BranchId);
          serviceForm.value.HospitalId = Number(usersData.OrganizationId);
          serviceForm.value.ModifiedBy = Number(usersData.UserId);
          serviceForm.value.CreatedBy = Number(usersData.UserId);
          serviceForm.value.UpdatedBy = usersData.UserId;
          serviceForm.value.ExpectedReturnDate = moment(
            serviceForm.value.ExpectedReturnDate,
            "DD-MM-YY"
          ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          serviceForm.value.ActualReturnDate = serviceForm.value
            .ActualReturnDate
            ? moment(serviceForm.value.ActualReturnDate, "DD-MM-YY").format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )
            : "2025-09-24T15:56:25.621+05:30";
          serviceForm.value.EntityId = Number(Entitydata.EntityId);
          serviceForm.value.OrganizationId = Number(usersData.OrganizationId);
          serviceForm.value.CostEstimate = Number(
            serviceForm.value.CostEstimate
          );
          serviceForm.value.StoreId = Number(ParamValues.value.StoreId);
          serviceForm.value.Id = tableId.value ? Number(tableId.value) : 0;
          serviceForm.value.ActualCost = Number(serviceForm.value.ActualCost);

          if (serviceForm.value.Id == "") {
            response = await AssetService.createdata(serviceForm.value);
            message = response["ErrorInfo"].ErrorCode;
            if (response["result"] == "Already" && message == null) {
              scheduleLoading.value = false;
              alreadyexistpop.value = true;
            } else if (message == null) {
              scheduleLoading.value = false;
              createpop.value = true;
            }
          } else {
            response = await AssetService.updatedata(serviceForm.value);
            message = response["ErrorInfo"].ErrorCode;
            if (response["result"] == "Already" && message == null) {
              scheduleLoading.value = false;
              alreadyexistpop.value = true;
            } else if (message == null) {
              scheduleLoading.value = false;
              updatepop.value = true;
            }
          }
        } catch (error) {}
      }
    };

    function closetrigger() {
      closedetailsrightsidebar();
      updatepop.value = false;
      createpop.value = false;
    }

    function alreadyclosetrigger() {
      closedetailsrightsidebar();
      alreadyexistpop.value = false;
    }

    return {
      t,
      sidebarwidth,
      scheduleLoading,
      assetList,
      maintenanceTypeList,
      technicianList,
      priorityList,
      statusList,
      technicianList,
      closedetailsrightsidebar,
      saveMaintenanceSchedule,
      ParamValues,
      LoadAsset,
      serviceForm,
      closetrigger,
      alreadyclosetrigger,
      alreadyexistpop,
      updatepop,
      createpop,
      reasonList,
      supplierList,
      GetCode,
      tableId,
      assetSelect,
      reasonChange,
      btnLabel,
    };
  },
});
</script>

<style scoped>
/* Extended sidebar styles */
.sidebar-container {
  display: flex;
  height: 100%;
  /* transition: all 0.3s ease; */
}

.sidebar-container.extended {
  flex-direction: row;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  /* transition: all 0.3s ease; */
}

.main-content.extended {
  flex: 0 0 50%;
  border-right: 1px solid #e9ecef;
  padding-right: 1rem;
}

.extended-content {
  flex: 0 0 50%;
  padding-left: 1rem;
  background-color: #f8f9fa;
  border-left: 1px solid #e9ecef;
  overflow-y: auto;
  animation: slideInRight 0.3s ease;
}

.extended-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 1rem;
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 99;
}
</style>
